module.exports = __webpack_public_path__ + "img/11825382_L.2801d400.png";